import { render, staticRenderFns } from "./TargetProfiles.vue?vue&type=template&id=3ea242d1&scoped=true"
import script from "./TargetProfiles.vue?vue&type=script&lang=ts"
export * from "./TargetProfiles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea242d1",
  null
  
)

export default component.exports